<template>
    <div class="flex justify-center items-center mt-5 cursor-pointer">
        <img class="icon-bin" src="@/assets/icon/ic-bin-brown.svg" @click="clickDeleveAccount()">
        <div class="text-16 text-a-brown-9f8273 ml-2" @click="clickDeleveAccount()">{{lbl.profile.delete_account}}</div>
    </div>
</template>
<script>
import ConfigManager from '@/config/ConfigManager.js';
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from '@/mixin/LocaleMixin';
//service
import BzbsProfile from '@/core/Account/service/BzbsProfile';
//helper
import Account from "@/helper/AccountHelper.js";

export default {
    mixins: [ModalMixin, LocaleMixin],
    inject: ['PlaceOrderStore'],
    methods: {
        clickDeleveAccount: function () {
            this.modal.confirmModal
                .clearModal()
                .setMsg(this.lbl.profile.modal_delete.msg)
                .setBtnOk(this.lbl.profile.modal_delete.btn)
                .show();
            this.modal.confirmModal.onClickOk(() => {
                this.tracking.event('moremenu','click_confirm_account_deletion');
                this.deleteAccount();
            });
        },

        deleteAccount: function () {
            return new Promise((resolve) => {
                BzbsProfile.deleteAccount().subscribe({
                    next: (data) => {
                        if (data.success) {
                            Account.removeCacheUser();
                            this.PlaceOrderStore.methods.removePlaceOrder();
                            window.location.replace('/home');
                            resolve(true);
                        }
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    },
                })
            });
        },

        openDeleteAccountWeb: function () {
            let url = ConfigManager.getMinorDeleteAccountLink(this.localeCode);
            window.open(url, '_blank');
        },
    },
}
</script>
<style lang="scss" scoped>
    .icon-bin {
        height: 14px;
    }
</style>
